<af-main-container [title]="('i18n_af_fraudReports#' + reportType) | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false">
    @if (!isDestroyed) {
        <af-full-table
            class="w-100 h-100"
            [filterFields]="filterFields"
            (tableUpdateListener)="loadFraudReports($event)"
            [dataSource]="dataSource"
            [totalElements]="filterHolderService.getState()?.response?.total"
            [filterEvent]="filterHolderService.getState()?.tableEvent.filter"
            [pageEvent]="filterHolderService.getState()?.tableEvent.page"
            [showImport]="false"
            [showExport]="false"
            emptyStateIconName="ic_empty_state_no_data"
            emptyStateTitleTranslationKey="i18n_af_emptyStateSubtitleNoData"
            totalElementsTranslationKey="i18n_af_labelTotalElementsFraudReports"
            placeholderContext="fraudReports"/>
    }
</af-main-container>

